/* eslint-disable import/prefer-default-export */

export const USER_CHANGED = 'USER_CHANGED';
export const FILE_EL_CHANGED = 'FILE_EL_CHANGED';
export const ORIGINAL_USER_CHANGED = 'ORIGINAL_USER_CHANGED';
